import { PageTitle } from '@shared/components/page-title/page-title';
import { DataTableComponent } from '@shared/components/data-table.component';
import { ActionMenu } from '@shared/components/action-menu/action-menu';

export const SHARED_IMPORTS = [
  PageTitle,
  DataTableComponent,
  ActionMenu
] as const;